import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { INode } from '@cbridge-packages/node';
import { ServerAction } from '../../server.action';

export const ServerListSubscriber: FunctionComponent<{ nodeId?: INode['nodeId'] }> = ({ nodeId }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ServerAction.loadList.started({ nodeId }));
  }, [dispatch, nodeId]);

  useEffect(() => {
    return () => {
      dispatch(ServerAction.destroy());
    };
  }, [dispatch]);

  return null;
};
